import React from 'react'
import ReactDOM from 'react-dom'
import ReactDOMClient from 'react-dom/client'
import ReactJSXRuntime from 'react/jsx-runtime'

window.React = React
window.ReactDOM = ReactDOM
window.ReactDOMClient = ReactDOMClient
window.ReactJSXRuntime = ReactJSXRuntime

React.jsx ||= ReactJSXRuntime.jsx
